import clsx from 'clsx'
import Link from 'next/link'
import {
  CrosslinkRow,
  getNearbyRows,
  getOtherOfferRows,
  getOtherOffersHeading,
  OFFER_NEARBY_HEADINGS,
} from './lib'
import { PageInfo } from '@/src/@types/models'
import Container from '@/src/components/layout/Container'

export default function Component({ pageInfo }: { pageInfo: PageInfo }) {
  const flchSettings = pageInfo.flchSettings
  const crosslinks = flchSettings?.crosslinks
  if (!flchSettings || !crosslinks) return null

  const nearbyRows = getNearbyRows(crosslinks)
  const otherRows = getOtherOfferRows(crosslinks)
  if (nearbyRows.length === 0 && otherRows.length === 0) return null

  const otherHeading = getOtherOffersHeading(
    crosslinks,
    flchSettings.locationName
  )

  return (
    <section className={clsx({ 'mt-20 md:mt-32': pageInfo.newSpacing })}>
      <Container>
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-6">
            <h2 className="text-4xl font-black md:text-20xl">
              Nützliche Infos rund um die Fahrausbildung
            </h2>
            <p className="text-lg text-gray-800">
              Alles für deinen Führerschein an einem Ort - finde
              Fahrlehrer:innen und Kurse in deiner Nähe.
            </p>
          </div>
          <div className="grid gap-8 md:grid-cols-2">
            {nearbyRows.length > 0 && (
              <CrosslinkCard
                title={OFFER_NEARBY_HEADINGS[crosslinks.currentOffer]}
                subtitle="Auch an diesen Standorten sind wir für dich da"
                rows={nearbyRows}
              />
            )}
            {otherRows.length > 0 && (
              <CrosslinkCard
                title={otherHeading.title}
                subtitle={otherHeading.subtitle}
                rows={otherRows}
              />
            )}
          </div>
        </div>
      </Container>
    </section>
  )
}

function CrosslinkCard({
  title,
  subtitle,
  rows,
}: {
  title: string
  subtitle: string
  rows: CrosslinkRow[]
}) {
  return (
    <div className="rounded-xl border border-gray-150 bg-gray-50 p-8">
      <div className="flex flex-col gap-3">
        <h3 className="text-xl font-black">{title}</h3>
        <p className="text-gray-600">{subtitle}</p>
      </div>
      <div className="mt-4">
        {rows.map((row) => (
          <Link
            key={row.key}
            href={row.href}
            className="group flex items-baseline justify-between gap-3 border-b border-gray-150 py-2"
          >
            <span className="font-bold text-blue-700">{row.label}</span>
            <span className="shrink-0 text-gray-800">
              {Math.round(row.distanceKm)} km
            </span>
          </Link>
        ))}
      </div>
    </div>
  )
}
